module.exports = __webpack_public_path__ + "img/1577608559.25f2ab69.jpg";